import { render, staticRenderFns } from "./WorkProcessRecord.vue?vue&type=template&id=2fc0d1f8&scoped=true"
import script from "./WorkProcessRecord.vue?vue&type=script&lang=js"
export * from "./WorkProcessRecord.vue?vue&type=script&lang=js"
import style0 from "./WorkProcessRecord.vue?vue&type=style&index=0&id=2fc0d1f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc0d1f8",
  null
  
)

export default component.exports